import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
 
    getalerts(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .get('v1/settings/alerts', { params: userData })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    postalerts(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('v1/settings/alerts', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
